<template>
    <div class="order-received-header">
        <!-- Ready for pickup state -->
        <template v-if="isAnyFulfillmentReady">
            <div class="icon ready-for-pickup" :class="{ circlein: animateIcon }">
                <i class="fal fa-arrow-right"></i>
            </div>
            <div class="state">
                {{ trans.fulfillmentPopover.readyForPickUp }}
            </div>
        </template>

        <!-- Order received state -->
        <template v-if="!isAnyFulfillmentReady">
            <div class="icon" :class="{ circlein: animateIcon }">
                <i class="fal fa-check"></i>
            </div>
            <div class="state">
                {{ trans.orderReceivedPopover.received }}
            </div>
        </template>

        <div class="ordernumber">{{ orderNumberFormatted }}</div>
    </div>
</template>

<script setup lang="ts">
    import { trans } from "@/app/localization/Trans";
    import { OrderHelper } from "@/data/util/OrderHelper";
    import { computed } from "vue";

    const props = defineProps<{
        isAnyFulfillmentReady: boolean;
        animateIcon: boolean;
        dailyOrderIncrement: number | undefined;
        orderNumber: string | undefined;
    }>();

    const orderNumberFormatted = computed(() =>
        props.dailyOrderIncrement !== undefined
            ? OrderHelper.padDailyIncrement(props.dailyOrderIncrement)
            : props.orderNumber
    );
</script>

<style lang="scss">
    @use "./../../../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../../../assets/styles/scss/shared/_variables.scss";

    .order-received-popover-content .order-received-header {
        .icon {
            margin: auto;
            height: 70px;
            width: 70px;
            border-radius: 35px;
            background-color: colors.$green;
            text-align: center;
            transform: translate3d(0, 20px, 0);
            opacity: 0;
            transition:
                transform 0.8s variables.$easeOutExpo,
                opacity 0.8s variables.$easeOutExpo;

            > .fal {
                display: inline-block;
                line-height: 70px;
                color: #fff;
                font-size: 30px;
                transform: rotate(120deg);
                opacity: 0;
                transition:
                    transform 1.2s variables.$easeOutExpo,
                    opacity 1.2s variables.$easeOutExpo;
            }

            &.circlein {
                transform: translate3d(0, 0, 0);
                opacity: 1;

                > .fal {
                    transform: rotate(0deg);
                    opacity: 1;
                }
            }

            &.ready-for-pickup {
                background-color: colors.$red;
            }
        }

        .state {
            font-size: 14px;
            font-weight: 700;
            text-align: center;
            padding: 19px 0 1px 0;
            line-height: 22px;
        }

        .ordernumber {
            font-weight: 600;
            font-size: 42px;
            text-transform: uppercase;
            padding: 1px 0 3px 0;
            text-align: center;
        }
    }
</style>
